import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../api/auth';
import { AuthLayout, Button, Input, Spinner } from '../components/ui';
import { getErrorMessage } from '../lib/error-messages';

export function LoginPage(): JSX.Element {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const loginMutation = useLogin();

  const handleLogin = async () => {
    if (!login.trim()) {
      setError('Введите логин');
      return;
    }
    if (!password) {
      setError('Введите пароль');
      return;
    }

    setError('');
    try {
      await loginMutation.mutateAsync({ login: login.trim(), password });
      navigate('/inbox', { replace: true });
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !loginMutation.isPending) {
      handleLogin();
    }
  };

  return (
    <AuthLayout
      subtitle="Operator Console"
      footer={<p className="text-text-secondary text-xs">Invite-only доступ</p>}
    >
      <>
          <h2 className="font-heading text-xl font-semibold text-text-primary mb-6">
            Вход
          </h2>

          <div className="space-y-4" onKeyDown={handleKeyDown}>
            <Input
              label="Логин"
              placeholder="Введите логин"
              value={login}
              onChange={setLogin}
              disabled={loginMutation.isPending}
              autoComplete="username"
              autoFocus
            />

            <Input
              label="Пароль"
              placeholder="Введите пароль"
              type="password"
              value={password}
              onChange={setPassword}
              error={error}
              disabled={loginMutation.isPending}
              autoComplete="current-password"
            />

            <Button
              variant="primary"
              size="lg"
              className="w-full"
              onClick={handleLogin}
              disabled={loginMutation.isPending || !login.trim() || !password}
            >
              {loginMutation.isPending ? (
                <span className="flex items-center gap-2">
                  <Spinner size="sm" />
                  Вход...
                </span>
              ) : (
                'Войти'
              )}
            </Button>
          </div>
      </>
    </AuthLayout>
  );
}
